import { useSelector } from 'react-redux';

import { type LiteQuote } from '@frontend/api';
import { VStack } from '@frontend/components';

// eslint-disable-next-line no-restricted-imports
import { getQuoteItems } from '../../data/reducer';
import PartSelector from './PartSelector';

type PartSelectionProps = {
  quote: LiteQuote;
};

const PartSelection = ({ quote }: PartSelectionProps) => {
  const quoteItems = useSelector(getQuoteItems);

  return (
    <VStack height="100%" width="100%" spacing={0}>
      {quoteItems.map((quoteItem, index) => (
        <PartSelector
          key={`part-selector-${quoteItem.id}`}
          index={index}
          quoteItem={quoteItem}
          quote={quote}
        />
      ))}
    </VStack>
  );
};

export default PartSelection;
